import { createElement, Fragment } from 'react';
// cjs module
import { default as unified } from 'unified';
import remarkParse from 'remark-parse';
import remark2rehype from 'remark-rehype';
// If you need to support HTML tags, remember to sanitize the output
// https://github.com/remarkjs/remark-rehype#example-supporting-html-in-markdown-properly
import rehypeSanitize from 'rehype-sanitize';
import rehypeReact from 'rehype-react';

// hast-util-sanitize merges `protocols` shallowly, so the full set has to be
// repeated. `tel` and `sms` are not in the GitHub schema, which is why a
// Console link such as [Call us](tel:1-123-456-7890) renders as an empty paragraph.
const sanitizeSchema = {
  protocols: {
    href: ['http', 'https', 'mailto', 'tel', 'sms', 'xmpp', 'irc', 'ircs'],
    cite: ['http', 'https'],
    src: ['http', 'https'],
    longDesc: ['http', 'https'],
  },
};

const processor = (components = {}) => {
  return unified()
    .use(remarkParse)
    .use(remark2rehype)
    .use(rehypeSanitize, sanitizeSchema)
    .use(rehypeReact, {
      createElement,
      Fragment,
      components,
    });
};

const renderMarkdown = (markdownText, components) => {
  return processor(components).processSync(markdownText).result;
};
export default renderMarkdown;
